<p-fieldset
    [toggleable]="true"
    [collapsed]="isForCancelled() ? true : false"
    [id]="id() + '-fieldset'"
    class="custom-fieldset"
    [class.custom-success-fieldset]="fieldsetColor() === 'green'"
    [class.custom-danger-fieldset]="fieldsetColor() === 'red'">
    <ng-template pTemplate="expandicon">
        <i class="fa-solid fa-chevron-up"></i>
    </ng-template>
    <ng-template pTemplate="collapseicon">
        <i class="fa-solid fa-chevron-down"></i>
    </ng-template>
    <ng-template pTemplate="header">
        <p>
            {{
                (isForCancelled()
                    ? ('orders.canceledReactionSummary' | translate)
                    : ('orders.reactionSummary' | translate)) + ' '
            }}
            @if (reactions().length) {
                <span class="number-of-reactions-label">{{
                    '(' +
                        numberOfReactions() +
                        ' ' +
                        (numberOfReactions() === 1
                            ? ('reaction' | translate).toLowerCase()
                            : ('reactions' | translate).toLowerCase()) +
                        ')'
                }}</span>
            }
        </p>
    </ng-template>

    @if (reactions().length) {
        <div class="reaction-summary-content content">
            @for (reaction of reactions(); track reaction; let i = $index) {
                <div>
                    @if (!isForCancelled() || (isForCancelled() && reaction.cancelledPrimersCount)) {
                        <div class="reaction-row" [ngClass]="i % 2 === 0 ? 'even' : 'odd'">
                            <div class="column">
                                <p [id]="'sample-name-' + i">
                                    {{ reaction.sampleName }}
                                </p>
                            </div>
                            <p-divider [layout]="'vertical'"></p-divider>
                            <div class="column">
                                <div class="label-value">
                                    <label>{{ 'orders.setup.orderSummary.reactionPrice' | translate }}:</label>
                                    <p class="price">
                                        {{ (isForCancelled() ? '-' : '') + reaction.primerPrice | currency }} x
                                        {{ isForCancelled() ? reaction.cancelledPrimersCount : reaction.primersCount }}
                                    </p>
                                </div>
                                <div class="label-value total">
                                    <label>{{ 'total' | translate }}:</label>
                                    <p>
                                        {{
                                            (isForCancelled() ? '-' : '') +
                                                (isForCancelled() && reaction.cancelledPrimersCount
                                                    ? reaction.primerPrice * reaction.cancelledPrimersCount
                                                    : reaction.primerPrice * reaction.primersCount) | currency
                                        }}
                                    </p>
                                </div>
                            </div>
                        </div>
                    }
                </div>
            }
        </div>
    } @else {
        <app-loader></app-loader>
    }
</p-fieldset>
